export default {
  type1: {
    MS: { r:[0,10], tx:[0,-50], unit: 'vw', o:[1,0] },
    DL: v => ({ r:[0,10], tx:[0,-50], unit: 'vw', o:[1,v] }),
  },
  type2: {}
};
